import React from 'react'
import { OmTabs } from '@owma/kit'

import JsonEditor from '../JsonEditor'
import SchemaJsonEditor from '../SchemaJsonEditor'

interface JsonEditorChooserProps {
  value?: any
  options?: any
  onChange?: (value: string) => void
  onError?: (error: any) => void
  onDirty?: () => void
  className?: string
  style?: React.CSSProperties
  inputAttrs?: any
}

interface JsonEditorChooserState {
  dirty: boolean
  controllingFocus?: boolean
}

class JsonEditorChooser extends React.PureComponent<
  JsonEditorChooserProps,
  JsonEditorChooserState
> {
  editorType: string = 'normal' // 'schema'

  curTabKey: string = '1'

  timeout: NodeJS.Timeout | undefined = undefined

  editor: any = null

  editorWithSchema: any = null

  div: HTMLDivElement | null = null

  constructor(props: JsonEditorChooserProps) {
    super(props)
    this.state = {
      dirty: false,
    }
  }

  componentDidMount(): void {
    const { value } = this.props

    this.setValue(value)
  }

  componentDidUpdate(prevProps: JsonEditorChooserProps): void {
    const { onDirty, value } = this.props
    const { dirty, controllingFocus } = this.state

    if (dirty === true && controllingFocus && onDirty) {
      onDirty()
    }

    if (dirty === true && !controllingFocus) {
      this.timeout = setTimeout(() => {
        this.setState({
          dirty: false,
        })
      }, 100)
    }

    if (controllingFocus) {
      clearTimeout(this.timeout)
    }

    if (prevProps.value !== value) {
      this.setValue(value)
      setTimeout(() => {
        this.setState({
          dirty: false,
        })
      }, 1)
    }
  }

  componentWillUnmount(): void {
    // this.editor.destroy()
    // delete this.editor
    clearTimeout(this.timeout)
  }

  getEditor = (): any => {
    switch (this.curTabKey) {
      case '2':
        return this.editorWithSchema
      case '1':
      default:
        return this.editor
    }
  }

  setValue = (value: any): void => {
    console.log(value)

    this.getEditor().setValue(value)

    if (this.div != null) {
      ;(this.div as any).value = value
      this.div.setAttribute('value', value)
    }
  }

  getValue = (): string => {
    return this.getEditor().getValue()
  }

  handleChange = (): void => {
    const { onChange } = this.props

    const value = this.getValue()

    if (onChange != null) {
      onChange(value)
    }

    if (this.div != null) {
      ;(this.div as any).value = value
      this.div.setAttribute('value', value)
    }
  }

  handleFocus = (): void => {
    this.setState({
      controllingFocus: true,
    })
  }

  handleBlur = (): void => {
    this.setState({
      controllingFocus: false,
    })
  }

  handleError = (e: any): void => {
    const { onError } = this.props

    console.log('handleError : ', e)

    if (onError != null) {
      onError({
        hasError: e.length > 0,
        errors: e,
      })
    }
  }

  onTabChange = (key: string): void => {
    console.log('onTabChange : ', key)
    if (this.curTabKey === key) {
      return
    }

    this.curTabKey = key
    switch (this.curTabKey) {
      case '2':
        {
          const v = this.editor.getValue()
          if (this.editorWithSchema != null) {
            this.editorWithSchema.setValue(v)
          }
        }
        break
      case '1':
      default: {
        if (this.editorWithSchema != null) {
          const v = this.editorWithSchema.getValue()
          this.editor.setValue(v)
        }
      }
    }
  }

  render(): React.ReactNode {
    const { className, style, onError, options, inputAttrs, value } = this.props

    const inputAttrs2 = {
      ...inputAttrs,
    }

    delete inputAttrs2.options

    return (
      <div
        className={className}
        ref={(div) => {
          this.div = div
        }}
      >
        <OmTabs
          style={style}
          defaultActiveKey="1"
          onChange={this.onTabChange}
          items={[
            {
              key: '1',
              label: 'JsonEditor',
              children: (
                <JsonEditor
                  ref={(ref) => {
                    this.editor = ref
                  }}
                  onError={onError}
                  onChange={this.handleChange}
                  options={options}
                  value={value}
                  {...inputAttrs2}
                />
              ),
            },
            {
              key: '2',
              label: 'SchemaJsonEditor',
              children: (
                <SchemaJsonEditor
                  ref={(ref) => {
                    this.editorWithSchema = ref
                  }}
                  onError={onError}
                  onChange={this.handleChange}
                  value={value}
                  {...inputAttrs}
                />
              ),
            },
          ]}
        />
      </div>
    )
  }
}

export default JsonEditorChooser
